document.addEventListener('DOMContentLoaded', () => {
  const quantityButtons = document.querySelectorAll('.quantity-selector__button');

  quantityButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const url = button.getAttribute('data-href');
      if (url) {
        fetch(url, { method: 'POST' })
          .then(response => {
            if (response.ok) {
              location.reload(); // Atualiza a página para refletir a mudança no carrinho
            } else {
              console.error('Erro ao atualizar o carrinho.');
            }
          })
          .catch(error => console.error('Erro:', error));
      }
    });
  });
});